import { render, staticRenderFns } from "./MpConfigCreateJS.vue?vue&type=template&id=7074ab9e&scoped=true&"
import script from "./MpConfigCreateJS.vue?vue&type=script&lang=js&"
export * from "./MpConfigCreateJS.vue?vue&type=script&lang=js&"
import style0 from "./MpConfigCreateJS.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./MpConfigCreateJS.vue?vue&type=style&index=1&id=7074ab9e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074ab9e",
  null
  
)

export default component.exports